import { z } from 'zod'

export const notificationEmailRequestSchema = z.object({
	toAddress: z.email(),
	subject: z.string().min(1),
	templateName: z.string().min(1),
	templateData: z.record(z.string(), z.unknown()),
	notificationType: z.string().min(1),
	notificationVersion: z.string().min(1),
	userId: z.uuid().optional(),
})

export type NotificationEmailRequestInput = z.infer<typeof notificationEmailRequestSchema>
